import React, { memo, useState, useEffect } from "react";
import { Box, FormControl } from "@material-ui/core";
import PropTypes from "prop-types";
import DropdownAutocomplete from "components/DropdownAutocomplete/DropdownAutocomplete";

const STORAGE_KEY_PREFIX = "filterComponentState_";

const FilterComponent = ({ filter, onFilterChange }) => {
  const storageKey = `${STORAGE_KEY_PREFIX}${filter.name}`;
  
  const [selectedMemberText, setSelectedMemberText] = useState(
    sessionStorage.getItem(storageKey) || filter.filtersListMembers[0].memberText
  );

  const handleSelectChange = (selectedValue) => {
    setSelectedMemberText(selectedValue);
    onFilterChange(filter.name, selectedValue);
  };

  useEffect(() => {
    sessionStorage.setItem(storageKey, selectedMemberText);
  }, [selectedMemberText, storageKey]);

  const renderFilterMembers = () => {
    return (
      <FormControl>
        <DropdownAutocomplete
          options={filter.filtersListMembers.map((member) => ({
            label: member.memberText,
            value: member.memberText,
          }))}
          selected={selectedMemberText}
          onSelect={(selectedValue) => {
            handleSelectChange(selectedValue.value);
          }}
          label="Select Member"
          minWidth="150px"
          disableClearable={true}
          fontSize="12px"
        />
      </FormControl>
    );
  };

  return (
    <Box maxWidth="150px">
      <h4>{filter.text}</h4>
      {renderFilterMembers()}
    </Box>
  );
};

FilterComponent.propTypes = {
  filter: PropTypes.shape({
    text: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    filtersListMembers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        memberText: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default memo(FilterComponent);
